import 'core-js/es6';
import 'raf/polyfill';

import React from 'react';
import { render } from 'react-snapshot';

import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom';
import { Switch, Route, Redirect } from 'react-router';
import initReactFastclick from 'react-fastclick';
initReactFastclick();
require('isomorphic-fetch');

// import registerServiceWorker from './registerServiceWorker';

render(
  <HashRouter>
    <Route component={App} path="/" />
  </HashRouter>,
  document.getElementById('root')
);

// WEBPACK FOOTER //
// ./src/index.js
